import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTrashAlt } from "react-icons/fa";
import './LinksComponent.css';
import '../formComponents.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function LinkInput({ id, name, url, onChange, onRemove }) {
    return (
        <motion.div
            className='singleLinkDiv'
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            layout
        >
            <input
                type="text"
                className='linksNameInputDiv'
                placeholder="Link name (required)"
                value={name}
                onChange={(e) => onChange(id, 'name', e.target.value)}
            />
            <textarea
                className='linksUrlInputDiv'
                placeholder="Paste the full link here..."
                rows={2}
                value={url}
                onChange={(e) => onChange(id, 'url', e.target.value)}
            />
            <button
                className='removeButton'
                onClick={() => onRemove(id)}
                type="button"
            >
                <FaTrashAlt />
            </button>
        </motion.div>
    );
}

export default function LinksComponent({ onChange, resetTrigger }) {
    const [links, setLinks] = useState([
        { id: Date.now(), name: '', url: '' }
    ]);

    useEffect(() => {
        setLinks([{ id: Date.now(), name: '', url: '' }]);
    }, [resetTrigger]);

    const handleChange = (id, field, value) => {
        const updated = links.map(link => link.id === id ? { ...link, [field]: value } : link);
        setLinks(updated);
        notifyParent(updated);
    };

    const handleAdd = () => {
        if (links.length >= 10) {
            toast.error("⚠️ Only 10 links are allowed per request.", {
                autoClose: 4000,
                position: "top-right"
            });
            return;
        }

        setLinks([...links, { id: Date.now(), name: '', url: '' }]);
    };


    const handleRemove = (id) => {
        let updated = links.filter(link => link.id !== id);
        if (updated.length === 0) {
            updated = [{ id: Date.now(), name: '', url: '' }];
        }
        setLinks(updated);
        notifyParent(updated);
    };

    const notifyParent = (updatedLinks) => {
        const cleaned = updatedLinks
            .filter(link => link.url.trim() !== '' && link.name.trim() !== '')
            .map(({ name, url }) => ({
                name: name.trim(),
                url: url.trim()
            }));

        // Report ALL links (even with errors) so the parent can validate
        if (onChange) {
            onChange(cleaned, updatedLinks);
        }
    };


    return (
        <div className='linksFormRow'>
            <div className='requestLabelDiv'>
                <h3 className='requestLabel'>Links</h3>
            </div>
            <div className='requestLabelNotesDiv'>
                <p className='requestLabelNotes'>🧠 Tip: Adding a link is faster and easier than uploading files. You can link to Teams, OneDrive, or any website — great for sharing large files or live documents! Just remember to give them a good name.</p>
            </div>
            <AnimatePresence>
                {links.map((link) => (
                    <LinkInput
                        key={link.id}
                        id={link.id}
                        name={link.name}
                        url={link.url}
                        onChange={handleChange}
                        onRemove={handleRemove}
                    />
                ))}
            </AnimatePresence>
            <button
                className='addNewButton'
                onClick={handleAdd}
                type="button"
            >
                + Add another link ({links.length}/10)
            </button>
        </div>
    );
}
